<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4 class="card-title">{{ isEditMode ? 'Edit Client' : 'Add Client' }}</h4>
            <p class="card-category">Complete client details</p>
          </div>
          <div class="card-body">
            <form [formGroup]="clientForm" (ngSubmit)="submitForm()">
              <div class="row">
                <!-- Full Name -->
                <div class="col-4">
                  <mat-form-field class="example-full-width w-100">
                    <mat-label>Full Name</mat-label>
                    <input matInput placeholder="Enter full name" formControlName="fullName" required />
                  </mat-form-field>
                </div>

                <!-- Email -->
                <div class="col-md-4">
                  <mat-form-field class="w-100">
                    <mat-label>Email (Optional)</mat-label>
                    <input matInput placeholder="Enter email" formControlName="email" type="email" />
                    <mat-error *ngIf="clientForm.get('email')?.hasError('email') && clientForm.get('email')?.touched">
                      Please enter a valid email address
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Phone Number -->
                <div class="col-md-4">
                  <mat-form-field class="w-100">
                    <mat-label>Phone Number</mat-label>
                    <input matInput placeholder="Enter phone number" formControlName="phoneNumber" required />
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <!-- Address -->
                <div class="col-md-12">
                  <mat-form-field class="w-100">
                    <mat-label>Address</mat-label>
                    <input matInput placeholder="Enter address" formControlName="address" required />
                  </mat-form-field>
                </div>
              </div>
              <!-- <div class="row"> -->
              <!-- google drive upload files-->
              <!-- <div class="col-md-12"> -->
              <!-- In any parent component -->
              <!-- <app-google-drive-uploader (filesUploaded)="onFilesUploaded($event)"></app-google-drive-uploader> -->

              <!-- </div> -->
              <!-- </div> -->
              <div class="row" *ngIf="!isEditMode">
                <!-- Upload files-->
                <div class="col-md-12">
                  <app-file-uploader [folder]="'client'"></app-file-uploader>
                </div>
              </div>
              <button mat-raised-button color="danger" type="submit" class="btn btn-danger pull-right" [disabled]="isSubmited">
                  {{ isEditMode ? 'Update Client' : 'Add Client' }}
                </button>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>